import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import "./styles/Profile.css";
import WebsiteFooter from "../components/WebsiteFooter";

const Profile = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const database = getDatabase();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsLoggedIn(true);
        setUserData(user);

        const userRef = ref(database, `Customers/${user.uid}`);
        try {
          const snapshot = await get(userRef);
          if (snapshot.exists()) {
            const userDetails = snapshot.val();
            setDeliveryDetails(userDetails.deliveryDetails || {});
          } else {
            console.log("No user data found");
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setIsLoggedIn(false);
        navigate("/Login");
      }
    });

    return () => unsubscribe();
  }, [auth, database, navigate]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!isLoggedIn) {
    return null; // Redirect handled by `navigate`
  }

  return (
    <>
      <div className="profile-container">
        <div className="overview-section">
          <h2>Overview</h2>
          <p>Name: {userData?.displayName || "N/A"}</p>
          <p>Email: {userData?.email || "N/A"}</p>
          <h2>Delivery Details</h2>
          <p>Full Name: {deliveryDetails.fullName || "N/A"}</p>
          <p>Address: {deliveryDetails.address || "N/A"}</p>
          <p>City: {deliveryDetails.city || "N/A"}</p>
          <p>State: {deliveryDetails.state || "N/A"}</p>
          <p>PIN: {deliveryDetails.pin || "N/A"}</p>
          <p>Phone: {deliveryDetails.phone || "N/A"}</p>
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Profile;
